import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import DropdownApi from '../../components/DropdownApi';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Grid } from '@mui/material';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { SelectButton } from 'primereact/selectbutton';
import { addRiskAssessment, getRiskAssessment, updateRiskAssessment } from '../../service/riskAssessmentService';
import { Calendar } from 'primereact/calendar';
import dayjs from 'dayjs';
import { getForm, submitForm } from '../../service/formService';
import { Form } from 'dsf-form-builder';
import { Toast } from 'primereact/toast';

export default function TaskFormSubmit(modalProps: any) {

  const id = modalProps?.id;
  const details = modalProps?.details;
  const [form, setForm] = React.useState<any>({});
  const [formConfig, setFormConfig] = React.useState<any>({});
  const toast = React.useRef(null as any);

  async function Submit() {
    let updateDetails: any = {
      task: details.id,
      form: form,
      client: modalProps.client_id,
    };
    modalProps.setGlobalLoading(true);
    submitForm(updateDetails).then((r: any) => {
      modalProps.toast.current.show({ severity: 'success', summary: 'Form Submitted Successfully', life: 3000 });
      modalProps.setVisible(false);
      modalProps.setGlobalLoading(false);
      modalProps.setReload(!modalProps.reload);
    }).catch((error) => {
      modalProps.toast.current.show({ severity: 'error', summary: 'Failed to Submit Form', life: 3000 });
      modalProps.setGlobalLoading(false);
    })
  }

  async function updateFormConfig(event: any) {
    console.log("event == ", event);
    setFormConfig(event);
  }

  React.useEffect(() => {
    modalProps.setGlobalLoading(true);
    getForm(id).then((r: any) => {
      setForm(r.form);
      setFormConfig(r.config);
      modalProps.setGlobalLoading(false);
    }).catch((error) => {
      modalProps.setGlobalLoading(false);
      console.log("error == ", error);
    });
  }, [])

  return (
    <div className="renderedForm">
      <React.Fragment>
        {
          form?.items?.length > 0 ? <Form form={form} onChange={updateFormConfig} config={formConfig} />
            : ""
        }
        <Button type="button" icon="pi pi-arrow-up" label="Submit" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 70, top: 75, color: "#2dd36f" }} onClick={() => Submit()} />

        <Toast ref={toast} />
      </React.Fragment>
    </div>

  );
}